import type { ConsentResponse } from "@/core/types";
import type { PolicyMetaData, ConsentedPolicy } from "@/core/types";
import type { UUID } from "@/core/types";
import { createVersionedAcknowledgementPayload } from "@/utils/acknowledgementUtilsTyped";
import { createConsentPayloadTyped } from "@/utils/consentUtilsTyped";

type ConsentPayloadParams = {
  consentResponse: ConsentResponse;
  consentType: ConsentedPolicy;
  patientId: UUID;
  policyMetadata: PolicyMetaData;
  policyVersion: string;
  consentGivenBy?: UUID;
};

export function getConsentPayload(params: ConsentPayloadParams) {
  const { consentResponse, consentType, patientId, policyMetadata, policyVersion, consentGivenBy } =
    params;

  const versionedAcknowledgementPayload = createVersionedAcknowledgementPayload({
    consentResponse,
    policyVersion,
    consentGivenBy,
  });

  const consentPayload = createConsentPayloadTyped({
    consent: versionedAcknowledgementPayload,
    consentType,
    patientId,
    policyMetadata,
  });

  return consentPayload;
}
